<template>
  <div class="date-summary">
    <template v-if="isRanged">
      <div>{{ yearOrDayOfWeek(startIso) }}</div>
      <div>
        {{ startIso | shortMonth }}
        {{ startIso | shortWeekday }}
      </div>
      <div class="range-divider"/>
      <div>
        {{ endIso | shortMonth }}
        {{ endIso | shortWeekday }}
      </div>
      <div>{{ yearOrDayOfWeek(endIso) }}</div>
    </template>
    <template v-else>
      <div class="month">{{ startIso | shortMonth }}</div>
      <div class="date">{{ startIso | shortDay }}</div>
      <div class="year-or-day">{{ yearOrDayOfWeek(startIso) }}</div>
    </template>
  </div>
</template>

<script>

export default {
  props: {
    isRanged: {
      type: Boolean,
      default: false
    },
    // YYYY-MM-DD format
    startIso:{
      type: Date
    },
    // YYYY-MM-DD format
    endIso:{
      type: Date
    }
  },
  methods: {

    yearOrDayOfWeek(date) {
      const isThisYear = date.getFullYear() === new Date().getFullYear()

      return isThisYear
        ? this.$options.filters.shortWeekday(date)
        : date.getFullYear()

    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixin.scss';
@import '../../assets/scss/var.scss';

.date-summary {
  display         : flex;
  flex-direction  : column;
  font-size       : 14px;
  justify-content : center;
  padding         : 0;
  text-align      : center;
  text-transform  : uppercase;

  .date {
    font-size   : 1.5rem;
    line-height : 1;
  }
}

.range-divider {

  border-top: 1px solid $color-grey-mid;
  height: 0;
  margin: 2px 0 4px 0;
  position: relative;

  &::before {
    @include triangle(bottom, $color-grey-mid, 3px);
    left: calc(50% - 1.5px);
    position: absolute;
    top: 0;
  }
}
</style>
